<div class="p-3 bg-white border-radius-default shadow-default d-flex align-items-center justify-content-center" style="min-height: 30em">
    <h1>{{ 'Recreation' | localize }}</h1>
</div>
